export default {
    name: "Fractal Bitcoin",
    coin: "FB",
    scheme: "SOLO",
    account: '1Z5cMCKPDQqZ5XGdGTrgrp2eWVCKvVb44',
    url: '',
    explorer_url: 'https://fractal.unisat.io/explorer',
    coingecko: 'https://www.coingecko.com/en/coins/fractal-bitcoin',
    explorer: {
        address: 'https://fractal.unisat.io/explorer/address/',
        height: 'https://fractal.unisat.io/explorer/block/',
        hash: 'https://fractal.unisat.io/explorer/block/',
        tx: 'https://fractal.unisat.io/explorer/tx/',
    },
    ports: [
        {
            info: 'LOW',
            vardiff: true,
            host: 'molepool.com',
            port: 1881,
            diff: 262144,
        },
        {
            info: 'MID',
            vardiff: false,
            host: 'molepool.com',
            port: 1802,
            diff: 1048576,
        },
        {
            info: 'HIGH',
            vardiff: false,
            host: 'molepool.com',
            port: 1803,
            diff: 10485760,
        },
    ]
};